module.exports = __webpack_public_path__ + "static/media/track.2b0d15db.png";